import React, { useState, useEffect, useRef } from "react";
import { useParams,useNavigate, useLocation } from "react-router-dom";
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { Box, Button, Grid, TextField } from "@mui/material";
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import api from "../api";
import { useDeletePunchEntry, usePostPunchEntry, useUpdatePunchEntry } from "../api/punch_entries";


const modalStyle = {
    position: 'absolute' ,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };

const TimeEntryDetailsView = (props) => {

    const location = useLocation()
    let navigate = useNavigate();
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const { mutate: addEntry } = usePostPunchEntry({
        onSuccess: () => {
            goBack()
        },
        onError: (error) => {
            setError(error.response.data)
        }
    })

    const { mutate: updateEntry } = useUpdatePunchEntry({
        onSuccess: () => {
            goBack()
        },
        onError: (error) => {
            setError(error.response.data)
        }
    })

    const { mutate: deleteEntry } = useDeletePunchEntry({
        onSuccess: () => {
            goBack()
        },
        onError: (error) => {
            setError(error.response.data)
        }
    })

    const [entry, setEntry] = useState({
        open_time:null,
        end_time: null,
        employee: location.state.employee

    })
    const [error, setError] = useState("")

    useEffect(() => {
        console.log(location.state)
        getEntry()
    }, [])

    useEffect(() => {
        window.addEventListener("popstate", goBack)
        return () => {
            window.removeEventListener("popstate", goBack)
        }
    }, [])

    const getEntry = async () => {
        if (location.state.id) {
            let res = await api.get('/punchentries/' + location.state.id)
            setEntry(res.data)
        }
    }

    const saveEntry = async (e) => {
        e.preventDefault();
        let res;
        if(location.state.id) {
            updateEntry(entry)

        }
        else {
            addEntry(entry)
        }
    }


    const goBack = () => {
        navigate('/timesheets', {state: {daterange: location.state.daterange, selectedIndex: location.state.selectedIndex}})
    }

    return(
        <div style={{ padding:"10px 64px"}}>
            <div className="page-title">
                <a onClick={goBack} className="back-arrow">
                        <FontAwesomeIcon icon={faArrowLeft}/>
                </a>
                <h1 >{"Modification d'une entrée de temps"}</h1>
            </div>

            <Box
                component="form"
                alignContent="center"
                width={"100%"}
                onSubmit={saveEntry}
                flex={1}
                display="flex"
                flexDirection={"column"}
                >
                <DateTimePicker
                    renderInput={(props) => <TextField required sx={{margin:"4px"}} {...props} />}
                    label="Début"
                    value={entry.open_time}
                    onChange={(newValue) => {
                        setEntry({...entry, open_time:newValue})
                }}
                />
                <DateTimePicker
                    renderInput={(props) => <TextField  required sx={{margin:"4px"}} {...props} />}
                    label="Fin"
                    value={entry.end_time}
                    onChange={(newValue) => {
                    setEntry({...entry, end_time:newValue});
                }}
                />



                <div>
                <Button 
                    type={"submit"} 
                    sx={{margin:"4px", float:"right"}}
                    variant="contained">
                        Sauvegarder
                </Button>

                {location.state.id && <Button 
                    variant="contained"
                    color="error" 
                    onClick={handleOpen}
                    sx={{margin:"4px", float:"right"}}>
                        Supprimer
                </Button>}
                </div>
                
            </Box>
            
            <p style={{color:"red", textAlign:"center"}}>{error}</p>

            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="delete-modal"
                aria-describedby="delete-modal"
                >
                <Box sx={modalStyle}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                    Supprimer l'employé?
                    </Typography>
                    <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                    Voulez-vous vraiment supprimer l'entrée ?
                    </Typography>
                    
                    <Button 
                        variant="contained"
                        color="error" 
                        onClick={() => deleteEntry({id:location.state.id})}
                        sx={{margin:"4px", float:"right"}}>
                            Supprimer
                    </Button>
                    <Button 
                        onClick={handleClose}
                        color="info"
                        sx={{margin:"4px", float:"right"}}
                        variant="contained"
                    >
                        Annuler
                    </Button>
                </Box>
            </Modal>
        </div>
    )
}
export default TimeEntryDetailsView